// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609240654/js/" + chunkId + "." + {"44":"585edf15","225":"72d1b957","481":"4e5c05f1","486":"ca2a4505","770":"b4313cc3"}[chunkId] + ".0.5266521501882901.chunk.js";
};